/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Mode_NoneInputs */

const bn_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনো মোড নির্বাচন করা হয়নি`)
};

const de_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Modus ausgewählt`)
};

const el_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν έχει επιλεγεί λειτουργία`)
};

const en_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No mode selected`)
};

const es_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ningún modo seleccionado`)
};

const fr_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun mode sélectionné`)
};

const hi_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मोड चयनित नहीं`)
};

const hu_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs mód kiválasztva`)
};

const id_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada mode yang dipilih`)
};

const it_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna modalità selezionata`)
};

const ja_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モードが選択されていません`)
};

const ko_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택된 모드 없음`)
};

const nl_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen modus geselecteerd`)
};

const pl_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wybrano żadnego trybu`)
};

const pt_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum modo selecionado`)
};

const ru_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим не выбран`)
};

const sv_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget läge valt`)
};

const tr_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mod seçilmedi`)
};

const uk_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Режим не вибрано`)
};

const vi_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có chế độ nào được chọn`)
};

const zh_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择模式`)
};

const zh_hant_session_mode_none = /** @type {(inputs: Session_Mode_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未選擇模式`)
};

/**
* | output |
* | --- |
* | "No mode selected" |
*
* @param {Session_Mode_NoneInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const session_mode_none = /** @type {((inputs?: Session_Mode_NoneInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Mode_NoneInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_session_mode_none(inputs)
	if (locale === "de") return de_session_mode_none(inputs)
	if (locale === "el") return el_session_mode_none(inputs)
	if (locale === "en") return en_session_mode_none(inputs)
	if (locale === "es") return es_session_mode_none(inputs)
	if (locale === "fr") return fr_session_mode_none(inputs)
	if (locale === "hi") return hi_session_mode_none(inputs)
	if (locale === "hu") return hu_session_mode_none(inputs)
	if (locale === "id") return id_session_mode_none(inputs)
	if (locale === "it") return it_session_mode_none(inputs)
	if (locale === "ja") return ja_session_mode_none(inputs)
	if (locale === "ko") return ko_session_mode_none(inputs)
	if (locale === "nl") return nl_session_mode_none(inputs)
	if (locale === "pl") return pl_session_mode_none(inputs)
	if (locale === "pt") return pt_session_mode_none(inputs)
	if (locale === "ru") return ru_session_mode_none(inputs)
	if (locale === "sv") return sv_session_mode_none(inputs)
	if (locale === "tr") return tr_session_mode_none(inputs)
	if (locale === "uk") return uk_session_mode_none(inputs)
	if (locale === "vi") return vi_session_mode_none(inputs)
	if (locale === "zh") return zh_session_mode_none(inputs)
	return zh_hant_session_mode_none(inputs)
});